<template>
    <svg
        id="icon_lobby_view_1_on"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="30.001"
        height="30"
        viewBox="0 0 30.001 30"
    >
        <defs>
            <linearGradient
                id="linear-gradient"
                x1="0.5"
                x2="0.5"
                y2="1"
                gradientUnits="objectBoundingBox"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#e3beff" />
            </linearGradient>
        </defs>
        <path
            id="Union_29"
            data-name="Union 29"
            d="M511-593a4,4,0,0,1-4-4,4,4,0,0,1,4-4h22a4,4,0,0,1,4,4,4,4,0,0,1-4,4Zm0-22a4,4,0,0,1-4-4,4,4,0,0,1,4-4h22a4,4,0,0,1,4,4,4,4,0,0,1-4,4Z"
            transform="translate(-507 623)"
            fill="url(#linear-gradient)"
        />
    </svg>
</template>
